<div class="related-provider">
  <a href="<%= provider.url %>">
    <div class="related-provider__image">
      <figure class="profile-picture">
        <img src="<%= provider.image_url %>" alt="<%- I18n.headshot_alt.replace('%{provider}', provider.name) %>"></img>
      </figure>
    </div>
  </a>

  <%= provider.ratings_html %>

  <a href="<%= provider.url %>" class="related-provider__link">
    <h3 class="related-provider__name"><%= provider.label %></h3>
    <p class="related-provider__specialty"><%= provider.specialties.map(function(specialty){ return specialty }).join(', ') %></p>
  </a>
</div>
